import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-33b28898"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "right_aside" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "客服", -1))
const _hoisted_5 = { class: "fixed_left" }
const _hoisted_6 = { class: "left_icon" }
const _hoisted_7 = ["src"]
const _hoisted_8 = { class: "right_info" }
const _hoisted_9 = { class: "text_qq" }
const _hoisted_10 = ["href"]
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { style: {"text-align":"center","display":"block"} }

import customerService from '@/api/customer-serivce';
import { useConfigStore } from '@/store';


import kficon from '@/assets/kf.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'curServe',
  setup(__props) {

const configStore = useConfigStore();


//在线服务时间
const onlineServiceTime = ref<string>('');


//客服QQ列表
const qqList = ref<{
    id?:number;
    sort?:string;
    titArea?:string;
    name?:string;
    qq?:string;
}[]>([]);


(() => {
    onlineServiceTime.value = configStore.config.onlineServiceTime;
    customerService.list().then((res:any) => {
        if(res.state === 'ok'){
            qqList.value = res.data;
        }
    })
})();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      (_unref(qqList).length > 0)
        ? (_openBlock(), _createElementBlock("li", _hoisted_2, [
            _createElementVNode("a", null, [
              _createElementVNode("img", { src: _unref(kficon) }, null, 8, _hoisted_3),
              _hoisted_4
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("ul", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(qqList), (item, index) => {
                  return (_openBlock(), _createElementBlock("li", { key: index }, [
                    _createElementVNode("div", _hoisted_6, [
                      _createElementVNode("img", { src: _unref(kficon) }, null, 8, _hoisted_7)
                    ]),
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", null, _toDisplayString(item.titArea), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("span", null, _toDisplayString(item.name) + "：", 1),
                        (item.name === 'QQ' || item.name === 'qq')
                          ? (_openBlock(), _createElementBlock("a", {
                              key: 0,
                              href: `https://wpa.qq.com/wpa_jump_page?v=3&uin=${item.qq}&site=qq&menu=yes`,
                              target: "_blank",
                              title: "点击咨询"
                            }, _toDisplayString(item.qq), 9, _hoisted_10))
                          : (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString(item.qq), 1))
                      ])
                    ])
                  ]))
                }), 128)),
                _createElementVNode("li", _hoisted_12, " 在线服务时间：" + _toDisplayString(_unref(onlineServiceTime)), 1)
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})